export default "__VITE_ASSET__BLKsMwvp__";